/**
 * Del MIME al rótulo corto que se pinta en la fila (`PDF`, `JPG`, `DOCX`).
 *
 * Cubre lo que el bucket REALMENTE tiene medido: pdf, jpeg, docx, xls, zip,
 * `message/rfc822` (correos) y octet-stream. Cero png, cero webp, cero video — así que
 * no se inventan ramas para formatos que nadie subió. Lo desconocido cae en `ARCHIVO`,
 * que es honesto y no rompe la fila.
 */
const MIME_LABEL: Record<string, string> = {
  'application/pdf': 'PDF',
  'image/jpeg': 'JPG',
  'image/jpg': 'JPG',
  'image/png': 'PNG',
  'application/msword': 'DOC',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
  'application/vnd.ms-excel': 'XLS',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
  'application/zip': 'ZIP',
  'message/rfc822': 'CORREO',
  'text/plain': 'TXT'
}

export function fileKindLabel(mimeType: string | null): string {
  if (!mimeType) return 'ARCHIVO'
  return MIME_LABEL[mimeType] ?? 'ARCHIVO'
}

/** `true` para lo que un visor puede mostrar en línea; el resto se descarga. */
export function isPreviewable(mimeType: string | null): boolean {
  if (!mimeType) return false
  return mimeType === 'application/pdf' || mimeType.startsWith('image/')
}
